import styled from 'styled-components';

import { Table } from 'features/common/components/Table';

export const Root = styled(Table.TableContainer)`
	margin: 0;
	width: 100%;
`;
